import { Button, Chip, Paper, Stack, Typography } from '@mui/material'
import styles from '@/components/Settings/GeneralSettingsContent.module.scss'
import shared from '@/components/Settings/settingsShared.module.scss'

/** @param {{ paperClassName: string }} props */
export function GeneralSettingsPrivacyModeCard({ paperClassName }) {
  return (
    <Paper elevation={0} className={paperClassName}>
      <Stack spacing={1.25} className={styles.privacyCardBody}>
        <Stack direction="row" className={styles.privacyTitleRow}>
          <Typography component="h3" variant="subtitle2" className={shared.settingsSectionHeading}>Privacy Mode (Legacy)</Typography>
          <Chip label="Active" size="small" color="success" variant="outlined" />
        </Stack>
        <Typography component="p" className={styles.privacyDescription}>
          Your code data will not be trained on or used to improve the product. We will not store your code.
          Cloud Agent and some features not available.
        </Typography>
        <Stack direction="row" className={styles.privacyActions}>
          <Button variant="outlined" size="small">Edit</Button>
          <Button variant="text" size="small">Learn More</Button>
        </Stack>
      </Stack>
    </Paper>
  )
}
